<!--
 * @Descripttion: 
 * @Author: juanjuanhui
 * @Date: 2021-11-15 15:08:28
 * @LastEditors: juanjuanhui
 * @LastEditTime: 2022-01-28 10:40:44
-->
<template>
  <el-footer height="70px">
    <div class="footer">
      <p class="p2">
        服务支持：金色大田科技有限公司
        <!-- <a href="https://beian.miit.gov.cn" target="_blank">
          京ICP备14027879号-23
        </a>
        <a href="http://www.beian.gov.cn" target="_blank">
          京公网安备11010802038807号
        </a> -->
      </p>
    </div>
  </el-footer>
</template>
<script>
export default {
  name: "Footer",
  data() {
    return {
      user: null,
    };
  },
  created() {
  },
};
</script>
<style lang="scss" scoped>
.footer {
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
  .p1 {
    color: #018388;
    font-size: 20px;
    font-weight: 900;
  }
  .p2 {
    margin-top: 10px;
    font-size: 16px;
  }
  p {
    text-align: center;
    color: #676f90;
    a {
      color: #676f90;
      margin-left: 10px;
      &:hover {
        color: #018388;
      }
    }
  }
}
</style>
